import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ExpecteLink } from "../../../../components/misc/Headings";
import { useParams } from "react-router-dom";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../../FireBaseConfig";

const FormContainer = styled.div`
    ${tw`flex justify-center items-center flex-grow`};
`;
const Container = styled.div`
    ${tw`w-full max-w-6xl p-8 bg-white shadow-lg rounded-lg border`};
    border: 2px solid #1BA557;
    border-radius: 15px;
    padding: 40px;
    display: grid;
    margin-top: 0px;
    grid-template-columns: 1fr 1fr; /* Two columns */
    column-gap: 60px; /* Bigger gap between columns for better spacing */
`;
const HighlightedText = styled.span`
    ${tw`text-primary-500`};
    color: #0ABD19;
`;
const StepTitle = tw(ExpecteLink)`w-full mt-2 mb-4`;

const Step3Backend = ({ onDeliveryCostUpdate }) => {
    const widgetInitialized = useRef(false);
    const [parcelData, setParcelData] = useState(null); // Данные посылки
    const [loading, setLoading] = useState(true); // Загрузка
    const { id } = useParams(); // Получение ID из URL

    // Функция получения данных посылки из Firebase
    async function fetchParcelData(parcelId) {
        const cleanId = parcelId.trim();

        try {
            const q = query(collection(db, "parcels"), where("id", "==", cleanId));
            const querySnapshot = await getDocs(q);

            if (!querySnapshot.empty) {
                querySnapshot.forEach((doc) => {
                    setParcelData(doc.data());
                });
            }
        } catch (error) {
            console.error('Error fetching parcel data:', error);
        }
    }

    useEffect(() => {
        if (id) {
            setLoading(true);
            fetchParcelData(id); // Загружаем данные посылки
        }
    }, [id]);

    // Инициализация виджета
    useEffect(() => {
        if (!parcelData) {
            return;
        }

        console.log('📦 Parcel data for CDEK:', parcelData);

        const { actualWeight, width, height, length } = parcelData;

        // Конвертация с проверкой на валидность
        const weightParsed = parseFloat(actualWeight);
        const widthParsed = parseFloat(width);
        const heightParsed = parseFloat(height);
        const lengthParsed = parseFloat(length);

        // Если данные невалидны, используем значения по умолчанию
        const weightInGrams = !isNaN(weightParsed) && weightParsed > 0
            ? Math.round(weightParsed * 453.592) // Фунты в граммы
            : 1000; // 1 кг по умолчанию

        const widthInCm = !isNaN(widthParsed) && widthParsed > 0
            ? Math.round(widthParsed * 2.54) // Дюймы в сантиметры
            : 10; // 10 см по умолчанию

        const heightInCm = !isNaN(heightParsed) && heightParsed > 0
            ? Math.round(heightParsed * 2.54) // Дюймы в сантиметры
            : 10; // 10 см по умолчанию

        const lengthInCm = !isNaN(lengthParsed) && lengthParsed > 0
            ? Math.round(lengthParsed * 2.54) // Дюймы в сантиметры
            : 10; // 10 см по умолчанию

        console.log('📐 Converted dimensions:', {
            weight: weightInGrams + 'g',
            width: widthInCm + 'cm',
            height: heightInCm + 'cm',
            length: lengthInCm + 'cm'
        });



        if (!widgetInitialized.current) {
            try {
                new window.CDEKWidget({
                    from: {
                        country_code: 'KZ',
                        city: 'Алматы',
                        postal_code: '050039',
                        address: 'ул. Беимбета Майлина 2, Алматы',
                    },
                    root: 'cdek-map',
                    apiKey: process.env.REACT_APP_CDEK_API_KEY || '5c3971a4-b56c-41ba-bb60-2aef6e535a26',
                    canChoose: true,
                    servicePath: 'https://us-central1-eparcel-kz.cloudfunctions.net/cdekWidgetProxy',
                    hideFilters: {
                        have_cashless: false,
                        have_cash: false,
                        is_dressing_room: false,
                        type: false,
                    },
                    hideDeliveryOptions: {
                        office: false,
                        door: true,
                    },
                    debug: false,
                    goods: [
                        {
                            weight: weightInGrams,
                            width: widthInCm,
                            height: heightInCm,
                            length: lengthInCm,
                        },
                    ],
                    defaultLocation: "Алматы",
                    lang: 'rus',
                    currency: 'KZT',
                    tariffs: {
                        office: [136],
                        door: [],
                    },
                    onReady() {

                    },
                    onCalculate(result) {

                    },
                    onChoose(mode, tariff) {
                        console.log('📍 CDEK Point selected:', tariff);

                        if (tariff && tariff.delivery_sum) {
                            // Передаем и стоимость доставки, и код ПВЗ
                            onDeliveryCostUpdate({
                                deliveryCost: tariff.delivery_sum,
                                deliveryPointCode: tariff.code || null, // Код пункта выдачи
                                deliveryPointAddress: tariff.address || null, // Адрес ПВЗ
                                tariffCode: tariff.tariff_code || 136 // Код тарифа CDEK
                            });
                            console.log('✅ Delivery cost:', tariff.delivery_sum, 'KZT');
                            console.log('✅ Delivery point code:', tariff.code);
                        } else {
                            console.warn('⚠️ No tariff data received');
                        }
                    },

                });

                widgetInitialized.current = true;
            } catch (error) {
                console.error('Error initializing CDEK widget:', error);
            }
        }
    }, [parcelData]);


    return (
        <FormContainer>
            <div style={{ width: "100%", maxWidth: "1280px" }}>
                <StepTitle active={true}>
                    <HighlightedText>Шаг 3. </HighlightedText>Выберите способ доставки
                </StepTitle>
                <Container>
                    <div id="cdek-map" style={{ width: "1000px", height: "600px", overflow: "hidden" }}></div>


                </Container>
            </div>
        </FormContainer>
    );
};

export default Step3Backend;
